export default {
  authorization: null
}
